import { Field} from 'formik';
import { Radio, RadioGroup, Stack, FormControl, Image,Box  } from '@chakra-ui/react';
import ElementInstructions from './components/ElementInstructions';
import ElementHeading from './components/ElementHeading';
import ElementErrorMessage from './components/ElementErrorMessage';
import { formatOptionLabel } from '../handlers/utils';
import { setInitialRadioButtonValue, handleRadioButtonChange } from './utils';
import { getResumeOrSectionIndex } from '../handlers';
import InputWrapper from './components/InputWrapper';

const RSRadio = ({ fieldName, qObj, props, styles }) => {
  const img_urls = qObj.option_images;
  const index = getResumeOrSectionIndex(props.stateProps, props.formikProps);
  const orientation =
    typeof qObj.orientation === 'undefined' ? 'row' : qObj.orientation;
  setInitialRadioButtonValue(props, qObj);
  return (
    <Field name={fieldName}>
      {({ field, form }) => {
        return (
          <Box id={qObj.qid}>
          <FormControl
            isInvalid={form.errors[qObj.id] && form.touched[qObj.id]}
          >
            <ElementHeading qObj={qObj} props={props} />
            <ElementInstructions instructions={qObj.instructions} />
            <InputWrapper>
              <RadioGroup
                label={qObj.question}
                id={qObj.id}
                {...field}
                colorScheme="orange"
              >
                <Stack direction={orientation}>
                  {qObj.options.map((option, option_index) => {
                    const checked = field.value === option.value ? true : false;
                    return (
                      <Radio
                        sx={{ ...styles.radio }}
                        name={fieldName}
                        {...field}
                        key={option.label}
                        value={option.value}
                        onChange={e =>
                          handleRadioButtonChange(
                            props.formikProps,
                            props.stateProps,
                            index,
                            qObj,
                            e.currentTarget.value,
                          )
                        }
                        checked={checked}
                      >
                        {typeof img_urls !== 'undefined' && (
                          <Image src={img_urls[option_index]} />
                        )}
                        {formatOptionLabel(option.value, option.label)}
                      </Radio>
                    );
                  })}
                </Stack>
              </RadioGroup>
            </InputWrapper>
            <ElementErrorMessage form={form} index={qObj.index} qid={qObj.qid} />
          </FormControl>
          </Box>
        );
      }}
    </Field>
  );
};

export default RSRadio;
